import { setupForDark } from '@theme';
import classNames from 'classnames';

function Label({
  text,
  type = 'primary'
}: {
  text: string;
  type?: 'primary' | 'secondary' | 'highlight';
}) {
  let colorClasses = setupForDark('bg-label-primary', 'text-secondary');
  if (type === 'secondary') {
    colorClasses = setupForDark('bg-label-dark', 'text-black');
  } else if (type === 'highlight') {
    colorClasses = setupForDark('bg-variable-turquoise', 'text-black');
  }

  return (
    <div
      className={classNames(
        'flex justify-center items-center gap-none pl-xxs pr-xxs rounded-xxs',
        colorClasses,
        'P6R'
      )}
    >
      {text}
    </div>
  );
}

export default Label;
